import entraUserManager from "../../utils/entraUserManager";
import { connect } from 'react-redux';
import React from 'react';

class SilentRenew extends React.Component {
    componentDidMount() {
        entraUserManager.signinSilentCallback().catch(console.error)
    }

    render() {
        return <div>...Refreshing tokens</div>
    }
}

function mapStateToProps(state) {
}

function mapDispatchToProps(dispatch) {
}

const connectedSilentRenew = connect(mapStateToProps, mapDispatchToProps)(SilentRenew);
export { connectedSilentRenew as SilentRenew };